import { arrayOf } from 'prop-types';
import React from 'react';

import { entityShape } from '../prop-types';

const getKey = entity => {
  return `${entity.id}-${new Date().getTime()}`;
};

class Project extends React.PureComponent {
  state = {
    entities: this.props.entities.map(entity => ({
      id: entity.id,
      key: getKey(entity),
      isExpanded: !!entity.isExpanded,
      isEditing: false,
      isEditable: true,
    })),
  };

  handleExpansionToggle(id) {
    this.setState(({ entities }) => ({
      entities: entities.map(entity =>
        id === entity.id
          ? { ...entity, isExpanded: !entity.isExpanded }
          : entity,
      ),
    }));
  }

  handleEdit(id) {
    if (this.state.entities.some(entity => entity.isEditing)) {
      return;
    }
    this.toggleEntityEditing(id, true);
  }

  handleSave(id) {
    this.toggleEntityEditing(id, false);
    this.setState(({ entities }) => ({
      entities: entities.map(entity =>
        entity.id === id ? entity : { ...entity, key: getKey(entity) },
      ),
    }));
  }

  handleCancel(id) {
    this.toggleEntityEditing(id, false);
  }

  toggleEntityEditing(id, isEditing) {
    this.setState(({ entities }) => ({
      entities: entities.map(entity => {
        if (isEditing) {
          return id === entity.id
            ? { ...entity, isEditing: true, isEditable: true, isExpanded: true }
            : { ...entity, isEditing: false, isEditable: false };
        }
        return { ...entity, isEditing: false, isEditable: true };
      }),
    }));
  }

  render() {
    return (
      <div>
        {this.props.entities.map(entity => {
          const { isExpanded, isEditing, isEditable, key } =
            this.state.entities.find(({ id }) => entity.id === id);
          return (
            <div className="mb-5" id={`entity-${entity.id}`} key={key}>
              <entity.Content
                onExpansionToggle={() => this.handleExpansionToggle(entity.id)}
                onEdit={() => this.handleEdit(entity.id)}
                onSave={() => this.handleSave(entity.id)}
                onCancel={() => this.handleCancel(entity.id)}
                isExpanded={isExpanded}
                isEditable={isEditable}
                isEditing={isEditing}
                keyVal={key}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

Project.propTypes = {
  entities: arrayOf(entityShape.isRequired).isRequired,
};

export default Project;
